import moment from 'moment-timezone';
import ReactDOMServer from 'react-dom/server';
import React from 'react';
import Highcharts from 'highcharts';
import {
  doTitle,
  toggleLabelsButton,
  toggleShowAllButton,
  updateChartLabelsButton,
  getNameOrLegendName,
  getSeriesWithLegendIndex,
} from '../Common';
import { views } from '../../constants/event';

const getViewChart = {
  [views.CHART]: 'line',
  [views.COLUMN_CHART]: 'column',
};

const toConversionConfig = ({ series }, { timezone }, view, unit, triggerLabels) => {
  const { id } = unit;
  const { steps } = unit.compose.funnels.funnel;

  const enabledSteps = steps.filter((step) => step?.enabled);
  const seriesWithLegendIndex = getSeriesWithLegendIndex(series);

  return {
    time: {
      getTimezoneOffset(timestamp) {
        return -moment.tz(timestamp, timezone).utcOffset();
      },
    },
    exporting: {
      enabled: true,
      contextButton: {
        menuItems: [
          'printChart',
          'separator',
          'downloadPNG',
          'downloadJPEG',
          'downloadPDF',
          'downloadSVG',
        ],
      },
      buttons: {
        showAll: {
          verticalAlign: 'bottom',
          align: 'left',
          text: doTitle('show all', false),
          onclick() {
            if (this.series.reduce((r, s) => s.visible && r, true)) {
              this.series.forEach((s) => {
                s.setVisible(false, false);
              });
            } else {
              this.series.forEach((s) => {
                s.setVisible(true, false);
              });
            }

            toggleShowAllButton(this);
          },
        },
        labels: {
          verticalAlign: 'bottom',
          align: 'left',
          text: doTitle('labels', true),
          onclick() {
            if (!this.labels) {
              this.zoomOut();
            }
            toggleLabelsButton(this);
            triggerLabels();
          },
        },
      },
    },
    groups: [],
    chart: {
      zooming: {
        type: 'x',
      },
      spacingLeft: 0,
      marginLeft: 50,
      events: {
        redraw({ target: chart }) {
          // функция убирает кнопку labels в режиме fullscreen графика и показывает кнопку при отключении fullscreen
          updateChartLabelsButton(chart, true, triggerLabels);

          if (chart.series[0]) {
            if (chart.showAll !== chart.series.every((s) => s.visible)) {
              toggleShowAllButton(chart);
            }
          }

          if (!!chart.legend && chart.legend.title !== undefined) {
            chart.legend.title.attr('x', chart.legend.legendWidth / 2);
            chart.legend.title.attr('text-anchor', 'middle');
          }
        },
      },
    },
    yAxis: {
      max: 100,
      title: {
        text: '',
      },
      labels: {
        formatter() {
          return `${this.axis.defaultLabelFormatter.call(this)}%`;
        },
      },
    },
    xAxis: {
      type: 'datetime',
      categories: null,
      min: null,
      max: null,
      events: {
        afterSetExtremes({ min, max }) {
          Highcharts.charts
            .filter((chart) => !!chart && chart.userOptions?.unitId === id)
            .forEach((chart) => chart.xAxis[0].setExtremes(min, max));
        },
      },
    },
    title: {
      text: '',
    },
    series: seriesWithLegendIndex.map((s, index) => {
      return {
        ...s,
        name: getNameOrLegendName(s, index, enabledSteps),
        type: getViewChart[view],
      };
    }),
    tooltip: {
      followPointer: view === views.COLUMN_CHART,
      formatter() {
        return ReactDOMServer.renderToStaticMarkup(
          <div>
            <b>{moment.tz(this.x, timezone).format('dddd D MMM YYYY', timezone)}</b>
            <br />
            <b>{this.series.name}</b>
            <br />
            <b>{this.key}</b>
            <br />
          </div>
        );
      },
      zIndex: 10,
    },
  };
};

export default toConversionConfig;
